import { Component, OnInit } from '@angular/core';
import { AbsLanguage } from '../../abstract/absLanguage';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/root.state';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { FieldConfig, FieldTypeEnum } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { CustomDropDownListOptions } from 'src/app/core/custom-drop-down-list/customDropDownList.interface';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/core/toast/toast.service';


export enum itLangEnum {
  'NameError' = 'NameError',
  'Sitetitle' = 'Sitetitle',
  'Test.One' = 'Test.One',
};

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  providers: [
    DatePipe,    
    TranslatePipe,
  ]
})
export class LanguageComponent extends AbsLanguage implements OnInit  {


  customDropOptions: CustomDropDownListOptions = {
    fields: { value: 'id', text: 'codice' },
    readonly: false,
    allowFiltering: true,
  };

  regConfig2:FieldConfig[]=[];

  constructor(protected override store: Store<AppState>,
      protected override translateService: TranslateService,
      private HttpClient: HttpClient,
      private TranslatePipe: TranslatePipe,
      private ToastService: ToastService,
      ){

        super(store,translateService);
        this.HttpClient.get(`${environment.baseHREF}/assets/i18n/it.json`).subscribe((e) => { console.warn(e) });
      }
  ngOnInit(): void {


    this.regConfig2 = [
      {
        type: FieldTypeEnum.input,
        name: 'nContratto',
        label: 'NR Contratto',
        readonly:true,
        value: 'VALORE',
      },
      {
        type: FieldTypeEnum.dateTime,
        name: 'dataStipula',
        label: 'Data stipula',
        isRequired: true,
        value: '',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una data',
          },
        ],
      },

      {
        name: 'aggiungi',
        type: FieldTypeEnum.button,
        label: 'Aggiungi',
        buttonType: 'submit',
        isDisabled: false,
        cssClass: 'e-primary e-success'

      },
      {
        name: 'annulla',
        type: FieldTypeEnum.button,
        label: 'Annulla',
        buttonType: 'button',
        isDisabled: false,
        cssClass: 'e-primary e-danger'
      },
      {
        type: FieldTypeEnum.select,
        name: 'tipo',
        label: 'Tipo',
        options:this.customDropOptions,
      },
      {
        type: FieldTypeEnum.select,
        name: 'cliente',
        label: 'Cliente',
        options:this.customDropOptions,
        value: '',
      },
      {
        type: FieldTypeEnum.dateTime,
        name: 'dataDecorrenza',
        label: 'Data decorrenza',
        isRequired: true,
        value: '',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una data',
          },
        ],
      },
      {
        type: FieldTypeEnum.dateTime,
        name: 'dataScadenza',
        label: 'Data scadenza',
        isRequired: true,
        value: '',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una data',
          },
        ],
      },
      {
        type: FieldTypeEnum.input,
        name: 'durataAnni',
        label: 'Durata anni',
        isRequired: true,
        value: '',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una data',
          },
        ],
      },

      {
        type: FieldTypeEnum.select,
        name: 'condizioniPagamento',
        label: 'Condizion Pagamento',
        options:this.customDropOptions,
      },
      {
        type: FieldTypeEnum.checkbox,
        name: 'rinnovoAutomatico',
        label: 'Rinnovo automatico',
      },
    ]
  }



    GenerateToast(){
      let toastTitle: string = this.TranslatePipe.transform(itLangEnum['Test.One']);
      
      let toastContent: string = this.TranslatePipe.transform(itLangEnum.NameError);                

      // test translation pipe from backend
      this.ToastService.GenerateToast({
        severity: 'e-toast-danger',
        title: toastTitle,
        content: toastContent,
        life: 5000,
      });
    }
}
